(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hld-signup-form"] && !Shopify.designMode) return;
  try {
    (function () {
    // --- One success message, on the form that was actually submitted ---
    //
    // Liquid's form.posted_successfully? is true for EVERY customer form on the
    // page once any one of them is posted, so the footer and the page card both
    // render the success state. Shopify redirects back with the submitted form's
    // id as the URL fragment (action="/contact#hld-nlp-form"), which is the only
    // thing that identifies the origin. Collapse the others.
    var posted = document.querySelectorAll('form.hld-signup__form .hld-signup__success');
    if (posted.length > 1) {
      var submittedId = (location.hash || '').replace('#', '');
      var keptOne = false;
      posted.forEach(function (panel) {
        var form = panel.closest('form.hld-signup__form');
        if (!form) return;
        var isSubmitted = submittedId ? form.id === submittedId : !keptOne;
        if (isSubmitted) {
          keptOne = true;
          return;
        }
        // Hide the whole card, not just the message — a bare empty card reads
        // as broken.
        var card = form.closest('.hld-card') || form;
        card.hidden = true;
      });
    }

    // Wires every signup form on the page independently, so the footer and an
    // in-page signup can coexist without sharing element ids or state.
    document.querySelectorAll('form.hld-signup__form').forEach(function (form) {
      if (form.dataset.hldSignupReady) return;
      form.dataset.hldSignupReady = '1';

      var step1 = form.querySelector('[data-hld-step="1"]');
      var step2 = form.querySelector('[data-hld-step="2"]');
      var nextBtn = form.querySelector('[data-hld-next]');
      var email = form.querySelector('[data-hld-email]');
      if (!step1 || !step2 || !nextBtn) return;

      // IMPORTANT — this form submits NATIVELY, never over fetch/XHR.
      //
      // Shopify's spam protection puts an hCaptcha token field in every
      // customer form, and only a real form submission gets that token
      // populated. Posting the FormData over fetch sends the token empty and
      // Shopify answers 400 "Missing CAPTCHA token" — so the signup is silently
      // lost. Worse, a fetch().then() runs on a 400 just as it does on a 200, so
      // an AJAX version cheerfully shows "You're in!" while capturing nobody.
      // That is exactly what this form did until 2026-07-27.
      //
      // navigator.sendBeacon has the same problem, so there is no abandonment
      // safety net here either — it could never pass the captcha.
      //
      // Native submit means the page reloads and Liquid's
      // `form.posted_successfully?` branch above renders the success panel.

      function syncTags() {
        var tags = form.querySelector('[data-hld-tags]');
        var dd = form.querySelector('[data-hld-dob-dd]');
        var mm = form.querySelector('[data-hld-dob-mm]');
        var yyyy = form.querySelector('[data-hld-dob-yyyy]');
        if (!tags) return;
        var base = tags.getAttribute('value') || 'checklist-signup';
        base = base.split(',')[0].trim();
        if (dd && mm && yyyy && dd.value && mm.value && yyyy.value) {
          tags.value = base + ', dob:' + yyyy.value + '-' + mm.value + '-' + dd.value;
        } else {
          tags.value = base;
        }
      }

      nextBtn.addEventListener('click', function () {
        if (email && !email.checkValidity()) {
          email.reportValidity();
          return;
        }
        if (window.omnisend && email && email.value) {
          try {
            window.omnisend.identifyContact({ email: email.value });
          } catch (e) {}
        }
        step1.hidden = true;
        step2.hidden = false;
        var firstField = step2.querySelector('select, input, button');
        if (firstField) firstField.focus();
      });

      // Write the dob: tag into the hidden field before the browser serialises
      // the form. Listeners run before serialisation, so no preventDefault is
      // needed — and none must be added, or the captcha token is lost again.
      form.addEventListener('submit', function () {
        syncTags();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
